import { Box } from '@chakra-ui/react';
import { useAppSelector } from 'modules/Editor/store';
import {
  selectInfographHeightPx,
  selectInfographWidthPx,
  selectPageBackgroundString,
} from 'modules/Editor/store/infographSelector';
import { memo } from 'react';

type PageVisionBackgroundProps = {
  pageId: string;
};

/**
 * PageVisionBackground component.
 * This component displays the page background that also includes the pattern and gradient.
 */
export const PageVisionBackground = ({ pageId }: PageVisionBackgroundProps) => {
  const widthPx = useAppSelector(selectInfographWidthPx);
  const heightPx = useAppSelector(selectInfographHeightPx);
  const pageBackground = useAppSelector(selectPageBackgroundString(pageId));

  return <Background widthPx={widthPx} heightPx={heightPx} pageBackground={pageBackground} />;
};

type BackgroundProps = {
  widthPx: number;
  heightPx: number;
  pageBackground: string;
};

const Background = memo(({ widthPx, heightPx, pageBackground }: BackgroundProps) => (
  <Box w={widthPx} h={heightPx} bg={pageBackground} />
));
Background.displayName = 'PageVisionBackground';
